/**
 * Single source of truth for the React Hook Form rollout flag's default.
 *
 * Read from:
 *  - `core/model/utils/featureFlags#activateReactHookForm` (browser)
 *  - `cy-testing` assessment e2e specs and `formHelpers.isReactHookForm`
 *
 * Flip this value to switch the whole assessment surface — including all
 * Cypress assessment specs — between the legacy `react-forms-state` form and
 * the RHF form, without having to touch each test.
 *
 * Kept dependency-free so it can be safely imported from the cy-testing
 * project as well.
 */
export const ACTIVATE_REACT_HOOK_FORM_DEFAULT = true;
